<template>
  <d2-container>
   <div class="supports">
      <div class="supportbanner">
      </div>
      <div class="supportcontent">
        <div class="supportcontcard">
          <h4 class="supportcontcardTitle">联系我们</h4>
          <el-form :model="form" status-icon :rules="rules" ref="ruleForm" label-width="18%" class="demo-ruleForm">
            <el-form-item label="称呼" prop="username" >
              <el-input v-model="form.username" placeholder="请输入您的称呼"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入您的电话"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" >
              <el-input v-model="form.email" placeholder="请输入您的邮箱地址"></el-input>
            </el-form-item>
            <el-form-item label="需求描述" prop="desc">
              <el-input type="textarea" :rows="5" v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item >
              <el-button type="primary" class="login-btn" @click="submitForm('ruleForm')" style="width: 125px;" >
                <span>提交</span>
              </el-button>
            </el-form-item>
          </el-form>
          </div>
      </div>

      <base-bottom></base-bottom>
   </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'

export default {
  name: 'hosting',
  components: {
    baseBottom
  },
  data() {
    return {
      form: {
        username: '',
        phone: '',
        email:'',
        desc:''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱地址', trigger: 'blur' }
        ],
      }
    }
  },
}
</script>

<style scoped>

.supports{
  min-height: 100vh;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F2F6FF 51%, #FFFFFF 100%);
}
.supportbanner{
  background: url(/image/portalimg/support/banner.png) no-repeat center center;
  width: 100%;
  height: 300px;
}
.supportcontent{
  background: url(/image/portalimg/support/card.png) no-repeat center center;
  width: 1560px;
  height: 760px;
  margin: -50px auto 80px;
}
.supportcontcard{
  width: 800px;
  margin: 0 auto;
}
.supportcontcardTitle{
  font-size: 38px;
  color: #000000;
  letter-spacing: 4px;
  text-align: left;
  font-weight: 400;
  padding: 80px 58px 40px;
  margin: 0;
}

.el-form-item{
  margin-bottom: 30px !important;
}

::v-deep .el-form-item__label {
    font-size: 18px !important; /* 根据需要调整 */
    padding-right: 50px;
    line-height: 52px;
}

::v-deep .el-input__inner {
    height: 50px; /* 调整高度 */
    line-height: 50px; /* 保证文本垂直居中 */
    font-size: 14px; /* 调整字体大小 */
}
::v-deep .item__error{
  top:58px;
}
::v-deep .el-input__suffix{
  top:0px
}
.login-btn span{
  color:#fff;
}
.el-textarea{
  margin-top: 0px !important;
}

@media (max-width: 768px) {
    /* 移动端样式 */

  .supports{
    min-height: 100vh;
    background-image: linear-gradient(180deg, #FFFFFF 0%, #F2F6FF 51%, #FFFFFF 100%);
  }
.supportbanner{
  background: url(/image/portalimg/support/banner.png) no-repeat center center;
  width: 100%;
  height: 150px;
  background-size: 100% 100%;
}
.supportcontent{
  background: url(/image/portalimg/support/card.png) no-repeat center center;
  width: 95%;
  height: 760px;
  margin: -50px auto 80px;
  height: auto;
  background-size: 100% 100%;
  padding-bottom: 30px;
}
.supportcontcard{
  width: 100%;
  margin: 0 auto;
}
.supportcontcardTitle{
  text-align: left;
  font-size: 20px;
  color: #000;
  letter-spacing: 2px;
  font-weight: 400;
  margin: 0;
  padding: 24px 7% 20px;
  font-weight: bold;
}

.demo-ruleForm{
  margin:0 5%;
}

.el-form-item{
  margin-bottom: 15px !important;
}

::v-deep .el-form-item__label {
    font-size: 12px !important; /* 根据需要调整 */
    line-height: 40px;
    padding-right: 10px;
}

::v-deep .el-input__inner {
    height: 35px; /* 调整高度 */
    line-height: 35px; /* 保证文本垂直居中 */
    font-size: 12px; /* 调整字体大小 */
}
::v-deep .item__error{
  top:58px;
}
.login-btn span{
  color:#fff !important;
}
.el-textarea{
  margin-top: 0px !important;
}

#c aptcha-element {
  width: 360px;
  height: 40px;
  margin-top: 10px;
}
#aliyunCaptcha-window-embed{
  z-index: 1 !important;
  padding: 8px 5px;
}
#supportcontcardMsg{
  margin-right: 5%;
}

}
</style>
